import { render, staticRenderFns } from "./MyPdf.vue?vue&type=template&id=5c2f971d&scoped=true"
import script from "./MyPdf.vue?vue&type=script&lang=js"
export * from "./MyPdf.vue?vue&type=script&lang=js"
import style0 from "./MyPdf.vue?vue&type=style&index=0&id=5c2f971d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f971d",
  null
  
)

export default component.exports